import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

import styles from "./Sidebar.module.css"
import guestii from '../../assets/images/logos/guestii_white.svg'
import guestii_gif from '../../assets/images/guestii_gif.gif'


const ToggleBar = ({ collapseSidebar, setCollapseSidebar }) => {
	const [collapseDeg, setCollapseDeg] = useState(0)

    const handleCollapse = async (control) => {
    	let intervalId;

        switch (control) {
            case 'enter':
            	if (collapseDeg !== 0) {
            		setCollapseDeg(0)
            	}

            	if (collapseDeg !== 15) {
	                intervalId = setInterval(() => {
	                    setCollapseDeg(prevDeg => {
	                        if (prevDeg >= 15) {
	                            clearInterval(intervalId);
	                            return prevDeg;
	                        }
	                        return prevDeg + 1;
	                    });
	                }, 10);
            	}
                break;
            case 'leave':
                intervalId = setInterval(() => {
                    setCollapseDeg(prevDeg => {
                        if (prevDeg === 0) {
                            clearInterval(intervalId);
                            return prevDeg;
                        }
                        return prevDeg - 1;
                    });
                }, 10);
                break;
             case 'toggle':
             	setCollapseDeg(0)
             	setCollapseSidebar(!collapseSidebar)
             	break;
        }
    };


	return (
		<div className={styles.toggle_bar_container}>
			<div 
				className={`${styles.collapseInner} ${collapseDeg === 0 && styles.collapseOpacitated}`}
				onMouseEnter={() => handleCollapse('enter')}
				onMouseLeave={() => handleCollapse('leave')}
				onClick={() => handleCollapse('toggle')}
			>
	        	<div className={styles.collapseBtn} style={{transform: `translateY(0.15rem) rotate(${collapseSidebar ? "-" : ""}${collapseDeg}deg) translateZ(0px)`}}></div>
	        	<div className={styles.collapseBtn} style={{transform: `translateY(-0.15rem) rotate(${(!collapseSidebar && collapseDeg !== 0) ? "-" : ""}${collapseDeg}deg) translateZ(0px)`}}></div>
	        </div>
		</div>

	)
}

const Sidebar = ({ current }) => {
	const [collapseSidebar, setCollapseSidebar] = useState(true)
    const [textVisible, setTextVisible] = useState(false);
    const [userId, setUserId] = useState(null)


	useEffect(() => {
		const handleLoad = async () => {
			const userId = localStorage.getItem("_id")
			if (!userId) {
				window.location = "/connect"
			} else {
				setUserId(userId)
			}
		}

		handleLoad()
	}, []);

    useEffect(() => {
        if (collapseSidebar) {
            setTimeout(() => setTextVisible(false), 200);
        } else {
            setTextVisible(true);
        }
    }, [collapseSidebar]);

    function handleLogout() {
		localStorage.removeItem("_id")
		localStorage.removeItem("expiry")
		window.location = "/connect"
    }
    

	return (
		<div className={styles.outer_sidebar}>
			<div className={!collapseSidebar ? styles.sidebar_container : styles.sidebar_container_half}>
				<div className={styles.nav_top}>
					{collapseSidebar
						?
							<Link to={`/hub/${userId}`}>
								<div className={styles.nav_top_inner}>
									<img src={guestii_gif}/>
								</div>
							</Link>
						: 
							<Link to={`/hub/${userId}`}>
								<div className={styles.nav_top_inner}>
									<img src={guestii}/>
								</div>
							</Link>
					}
				</div>

				<div className={styles.sidebar_grid}>
					<Link to={`/hub/${userId}`}>
						<div className={`${collapseSidebar ? styles.sidebar_box : styles.sidebar_box_full} ${current === "Hub" && styles.sidebar_active}`}>
							<div className={styles.sidebar_icon_container}>
								<i className={`fa-duotone fa-solid fa-objects-column ${collapseSidebar ? styles.sidebar_icon : styles.sidebar_icon_full}`} />
							</div>
                            <p className={`${styles.s3} ${current === "Hub" ? styles.sidebar_p_active : styles.sidebar_p} ${collapseSidebar ? (textVisible ? styles.text_hidden : styles.text_hidden_delay) : styles.text_fade}`}>{textVisible && "Hub"}</p>
						</div>
					</Link>

					<Link to={`/guestiis/${userId}`}>
						<div className={`${collapseSidebar ? styles.sidebar_box : styles.sidebar_box_full} ${current === "Guestiis" && styles.sidebar_active}`}>
							<div className={styles.sidebar_icon_container}>
								<i className={`fa-duotone fa-solid fa-rectangle-history-circle-user ${collapseSidebar ? styles.sidebar_icon : styles.sidebar_icon_full}`} style={{'--fa-primary-opacity': '0.4', '--fa-secondary-opacity': '1'}}/>
							</div>
                            <p className={`${styles.s3} ${current === "Guestiis" ? styles.sidebar_p_active : styles.sidebar_p} ${collapseSidebar ? (textVisible ? styles.text_hidden : styles.text_hidden_delay) : styles.text_fade}`}>{textVisible && "Guestiis"}</p>
						</div>
					</Link>

					<Link to={`/team/${userId}`}>
						<div className={`${collapseSidebar ? styles.sidebar_box : styles.sidebar_box_full} ${current === "Team" && styles.sidebar_active}`}>
							<div className={styles.sidebar_icon_container}>
								<i className={`fa-duotone fa-solid fa-users-medical ${collapseSidebar ? styles.sidebar_icon : styles.sidebar_icon_full}`} style={{'--fa-primary-opacity': '0.4', '--fa-secondary-opacity': '1'}} />
							</div>
                            <p className={`${styles.s3} ${current === "Team" ? styles.sidebar_p_active : styles.sidebar_p} ${collapseSidebar ? (textVisible ? styles.text_hidden : styles.text_hidden_delay) : styles.text_fade}`}>{textVisible && "Team"}</p>
						</div>
					</Link>
				</div>

				<button className={`${styles.nav_btn} ${styles.nav_bottom} ${collapseSidebar ? styles.sidebar_box : styles.sidebar_box_full}`} onClick={() => handleLogout()}>
					<div className={styles.sidebar_icon_container}>
						<i className={`fa-duotone fa-solid fa-left-from-bracket ${collapseSidebar ? styles.sidebar_icon : styles.sidebar_icon_full}`}  style={{'--fa-primary-opacity': '0.4', '--fa-secondary-opacity': '1'}}/>
					</div>
	                <p className={`${styles.s3} ${styles.sidebar_p} ${collapseSidebar ? (textVisible ? styles.text_hidden : styles.text_hidden_delay) : styles.text_fade}`}>{textVisible && "Logout"}</p>
				</button>
			</div>

			<ToggleBar { ... { collapseSidebar, setCollapseSidebar } }/>
		</div>
	);
};

export default Sidebar;